import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';
import styles from './LandingPage.scss';
import AccountSignupForm from '../../components/shared/AccountSignupForm';
import { LANDING_PAGE } from '../../utils/onboarding';

import headerImageSmall from './images/devices-header.jpg';
import headerImageLarge from './images/devices-header@2x.jpg';

const LandingPage = ({
  cohort,
  locale,
  config,
  authorizationUrls,
  flashMessage
}) => {
  useEffect(() => {
    trackV2({
      category: 'onboarding',
      page: 'home',
      action: 'screen_enter',
      properties: {
        cohort
      }
    });
  }, [cohort]);

  return (
    <div className={styles.main}>
      <div className={styles.row}>
        <div className={styles.col}>
          <h2>{I18n.t('components.landing_page.heading')}</h2>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.col}>
          <img
            className={styles.headerImage}
            src={headerImageSmall}
            srcSet={`${headerImageSmall} 1x, ${headerImageLarge} 2x`}
            alt=""
          />
        </div>
        <div className={styles.col}>
          <AccountSignupForm
            config={config}
            page={LANDING_PAGE}
            authorizationUrls={authorizationUrls}
            flashMessage={flashMessage}
            locale={locale}
          />
        </div>
      </div>
    </div>
  );
};

LandingPage.defaultProps = {
  flashMessage: null
};

LandingPage.propTypes = {
  cohort: PropTypes.oneOf(['control', 'variant-a']).isRequired,
  locale: PropTypes.string.isRequired,
  config: PropTypes.shape({
    appleEnabled: PropTypes.bool.isRequired,
    appleState: PropTypes.string.isRequired // https://developer.apple.com/documentation/sign_in_with_apple/clientconfigi/3230956-state
  }).isRequired,
  authorizationUrls: PropTypes.shape({
    google: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired
  }).isRequired,
  flashMessage: PropTypes.string
};

export default LandingPage;
